export { LastReceived } from './LastReceived';



// WEBPACK FOOTER //
// ./src/vp-ui/components/LastReceived/index.js